import { Component } from 'react';
import { Card } from 'react-bootstrap'
import { paperPlaneIcon, expandIcon } from '../../img/font_awesome/font_awesome';
import LatestNewsBig from './LatestNewsBig';
import translations from "../../config/translation/home_translations.json"
import axios from "axios";
import configData from "../../config/config.json";
import { handleError } from '../../redux/actions/commonStuff';
import { LOADING_STATUES } from "../constants/constants";

class LatestNews extends Component {
    state = {
        showModal: false,
        newsItems: [],
        loadingStatus: ""
    }
    
    handleKeyDown = (event) => {
        // 13 is Enter. 
        if (event.type === 'keydown' && event.keyCode === 13) {
            this.setState({
                 showModal: true
            })
        }
    }

    handleClick = () => {
        this.setState({
            showModal: true
        })
    }

    handleClose = () => {
        this.setState({
            showModal: false
        })
    }

    showLoading = () => {
        if (this.state.loadingStatus === "") {
            this.setState({
                loadingStatus: LOADING_STATUES.LOADING
            })
            return true;
        }
        return false;
    }

    hideLoading = () => {
        this.setState({
            loadingStatus: ""
        })
    }

    componentDidMount() {
        this.showLoading();
        axios.get(configData.LANDNOTIFICATION_SERVER_URL + "home/latestNews?language=" + this.props.language, { withCredentials: true })
            .then(
                (response) => {
                    const content = response.data.content;
                    let newsItems = content.paragraphs;
                    if (!newsItems || newsItems.length === 0) {
                        newsItems = []
                    }

                    this.setState({
                        newsItems
                    }, function () {   // callback function after the state is set
                        this.hideLoading();
                    });
                },
                (error) => {
                    handleError(error, this.props.history);
                }
            );
    }

    render() {
        let expandSpan = <></>
        if (this.state.newsItems) {
            expandSpan = <span onClick={this.handleClick} onKeyDown={this.handleKeyDown} tabIndex={0} style={{ cursor: "pointer", float: 'right' }}>{expandIcon}<span className="sr-only">Expand Latest News Window</span></span>
        }

        return (
            <>
                <Card>
                    <Card.Header className='card-header-light' >
                        {paperPlaneIcon}&nbsp;&nbsp;{translations[this.props.language].latest_news}{expandSpan}
                    </Card.Header>
                    <Card.Body style={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 0 }}>
                        <ul className='list-card' style={{ listStyle: 'none', paddingLeft: 0, marginLeft: 20 }}  >
                            <li>&nbsp;</li>
                            {
                                this.state.newsItems.map((newsItem, index) => {
                                    return <li key={index}><span style={{ fontWeight: 'bold' }}>{newsItem.heading}</span>&nbsp; {newsItem.paragraphContent}</li>
                                })
                            }
                        </ul>
                    </Card.Body>
                </Card>
                <LatestNewsBig show={this.state.showModal} newsItems={this.state.newsItems} handleClose={this.handleClose} />
            </>
        )
    }
}

export default LatestNews;